import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { SettingsSection } from "components/Settings/SettingsSection";
import { Link } from "react-router-dom";
import { useLoadCounter } from "hooks/useLoadCounter";

export const MachinesSection = () => {
  const {
    loading: machineModelsLoading,
    error: machineModelsError,
    response: machineModelsResponse
  } = useFetchGetV2("machines?ordering=id");
  const tableLoadCount = useLoadCounter(machineModelsLoading);

  if (machineModelsLoading) {
    return <></>;
  }

  if (machineModelsError) {
    return <></>;
  }

  if (machineModelsResponse) {
    return (
      <>
        <SettingsSection title="Machines">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell data-col={1}>ID</TableCell>
                  <TableCell data-col={2}>Name</TableCell>
                  <TableCell data-col={3}>Model</TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                data-qa_loading={machineModelsLoading}
                data-qa_load_count={tableLoadCount}
              >
                {machineModelsResponse &&
                  machineModelsResponse?.results.map(machine => (
                    <TableRow key={machine.id}>
                      <TableCell data-col={1}>{machine.id}</TableCell>
                      <TableCell data-col={2}>
                        <Link to={`/pages/settings/machine/${machine.id}`}>
                          {`${machine.name}`}
                        </Link>
                      </TableCell>
                      <TableCell data-col={3}>{`${machine.model}`}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SettingsSection>
      </>
    );
  }
};
